import guidePlaceholder from 'assets/images/placeholders/book.svg';
import { ImageFallback, TextLink, Typography } from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

import styles from './GuideCard.module.css';

export const GuideCard = ({ guide }) => {
  const { trackEvent } = useAnalytics();
  const title = guide.display_title ?? '';
  return (
    <div className={styles.guideCard}>
      <div className={styles.imgWrapper}>
        <ImageFallback src={guide.image_url} fallback={guidePlaceholder} />
      </div>
      <div className={styles.section}>
        <Typography variant='heading-s' className={styles.guideTitle}>
          {guide.display_title}
        </Typography>
        <Typography variant='caption' className={styles.description}>
          {guide.description}
        </Typography>

        <TextLink
          to={guide.url}
          external
          label='Read more'
          onClick={() => {
            trackEvent('Resource Content Clicked', {
              resource_type: 'guide',
              content_title: title,
            });
            trackEvent('Resource Read More Clicked', {
              content_title: title,
            });
          }}
        />
      </div>
    </div>
  );
};
